import { ENV } from '../config/env';
import { ENVS } from './types';

const CUSTOMER_APP_URLS: Record<ENVS, string> = {
  local: 'http://localhost:8000',
  dev: 'https://customer.pelicargo.dev',
  stg: 'https://staging-1.boardwalk.pelicargo.com',
  prd: 'https://app.pelicargo.com',
};

const ADMIN_APP_URLS: Record<ENVS, string> = {
  local: 'http://localhost:8001',
  dev: 'https://admin.pelicargo.dev',
  stg: 'https://staging-1.boardwalk.pelicargo.com:8008',
  prd: 'https://app.pelicargo.com:8008',
};

interface GetAppUrlOptions {
  customEnv?: ENVS;
  params?: Record<string, string>;
}

const getAppUrl = (urlType: Record<ENVS, string>, path: string, options?: GetAppUrlOptions) => {
  const env: ENVS = options?.customEnv || (ENV.APP_ENV as ENVS) || ('dev' as ENVS);

  const baseUrl = urlType[env];
  const url = new URL(baseUrl);

  if (path) url.pathname = path;
  if (options?.params) {
    for (const [key, value] of Object.entries(options.params)) {
      url.searchParams.append(key, value);
    }
  }

  return url?.toString();
};

export const getCustomerUrl = (path: string, options?: GetAppUrlOptions) => {
  return getAppUrl(CUSTOMER_APP_URLS, path, options);
};

export const getAdminUrl = (path: string, options?: GetAppUrlOptions) => {
  return getAppUrl(ADMIN_APP_URLS, path, options);
};
